import moment from 'moment';

export const AcGetHumanizedGreeting = m => {
  m = m || moment();
  let g = null; //return g

  if (!m || !m.isValid()) {
    return;
  } //if we can't find a valid or filled moment, we return.

  const split_afternoon = 12; //24hr time to split the afternoon
  const split_evening = 17; //24hr time to split the evening
  const current_hour = parseFloat(m.format('HH'));

  if (current_hour >= split_afternoon && current_hour <= split_evening) {
    g = 'good-afternoon';
  } else if (current_hour >= split_evening) {
    g = 'good-evening';
  } else {
    g = 'good-morning';
  }

  return g;
};

export default AcGetHumanizedGreeting;
